// redux/slices/dashboardSlice.js
import { createSlice } from "@reduxjs/toolkit";

const dashboardSlice = createSlice({
  name: "dashboard",
  initialState: {
    loading: false,
    data: {},
    error: null,
    birthdayLoading: false,
    birthdayData: {},
    birthdayError: null,
  },
  reducers: {
    getDashboardRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    getDashboardSuccess: (state, action) => {
      state.loading = false;
      state.data = action.payload;
    },
    getDashboardFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
     getBirthdayCustomersRequest: (state, action) => {
      state.birthdayLoading = true;
      state.birthdayError = null;
    },
    getBirthdayCustomersSuccess: (state, action) => {
      state.birthdayLoading = false;
      state.birthdayData = action.payload;
    },
    getBirthdayCustomersFailure: (state, action) => {
      state.birthdayLoading = false;
      state.birthdayError = action.payload;
    },
  },
});

export const {
  getDashboardRequest,
  getDashboardSuccess,
  getDashboardFailure,
  getBirthdayCustomersRequest,
  getBirthdayCustomersSuccess,
  getBirthdayCustomersFailure,
} = dashboardSlice.actions;

export default dashboardSlice.reducer;
